import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: `button-close`,
  template: `
    <button class="btn btn-primary d-print-none {{btnClass}}" (click)="onClick()" [disabled]="disabled"
            aria-label="Close" ngbTooltip="Close">
      <i class="fa fa-times" aria-hidden="true"></i> {{ label }}
    </button>
  `
})
export class ClosebuttonComponent {
  @Output() btnClick = new EventEmitter();
  @Input() disabled = false;
  @Input() btnClass = '';
  @Input() label = '';

  onClick(): void {
    this.btnClick.emit();
  }
}
